<svelte:options tag={null} />

<script lang="ts">
  import type { FlagTheme } from './flag.types';

  export let bordered = false;
  export let label: string;
  export let theme: FlagTheme;
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function getAppearanceClass(theme: FlagTheme, isBordered: boolean): string {
    if (!isBordered && !theme) {
      return '';
    }

    const type = isBordered ? 'bordered' : 'solid';

    if (theme) {
      return `mc-flag--${type}-${theme}`;
    }
    return `mc-flag--${type}`;
  }

  function setClasses(theme: FlagTheme, isBordered: boolean) {
    const classes = ['mc-flag'];

    const appearanceClass = getAppearanceClass(theme, isBordered);
    if (appearanceClass) {
      classes.push(appearanceClass);
    }

    return classes.join(' ');
  }
</script>

<div class="{setClasses(theme, bordered)} {userClass}" {...attributes}>
  <span class="mc-flag__label">{label}</span>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.flag';
</style>
